export const getInitialState = () => ({
	wixToken: null
});
